import { StatusCodes } from 'http-status-codes'

import type { ApiFetchReturnType, ApiOptionalOptions } from '@layers/web/utils/types/api-fetch.ts'
import { CACHE_RELOAD_QUERY } from '@layers/web/constants/cache.ts'

export const withBackendCacheReload = (request: string): string => {
  const { public: { previewMode } } = useRuntimeConfig()

  if (!previewMode || request.includes('cache_reload')) {
    return request
  }

  const separator = request.includes('?') ? '&' : '?'
  return `${request}${separator}${CACHE_RELOAD_QUERY}`
}

export const apiFetch = async <ApiResponse = any>(
  request: string,
  options: ApiOptionalOptions = {}
): Promise<ApiFetchReturnType<ApiResponse>> => {
  const requestOptions = createRequestOptions(options, request)
  const { throwOnFail, simple } = requestOptions

  if (!isValidFileType(request, requestOptions)) {
    return {
      data: {} as ApiResponse,
      error: { message: 'Invalid file type', statusCode: StatusCodes.UNSUPPORTED_MEDIA_TYPE },
    }
  }

  const headers = createRequestHeaders(requestOptions)

  logHttpRequest(request, requestOptions)

  const apiUrl = createApiUrl(request, requestOptions)

  const shouldRetryOnNetworkError = requestOptions.retryOnNetworkError === true && import.meta.client

  try {
    const response = await (shouldRetryOnNetworkError
      ? requestWithNetworkRetry(apiUrl, requestOptions, headers)
      : makeHttpRequest(apiUrl, requestOptions, headers))

    parseHttpResponseToCookie(simple, response)

    Object.assign(response, {
      data: response._data as ApiResponse,
      error: null,
    })

    return response as ApiFetchReturnType<ApiResponse>
  } catch (error) {
    return logFailedHttpRequest(error, throwOnFail)
  }
}
